import { GenericState } from '../../../common/store/types';
import { onApiCall } from '../../../common/store/generic.reducer';
import { exportActions } from './export.actions';
import { Action, ActionReducer, createReducer } from '@ngrx/store';
import { FileModel } from './types';

export interface IExportState {
  exportToCsv: GenericState<FileModel>;
}

export const exportInitialState: IExportState = {
  exportToCsv: new GenericState<FileModel>(),
};
const exportReducers = [
  ...onApiCall<FileModel>(exportActions.exportToCsv, 'exportToCsv'),
];
export const exportReducer = createReducer(
  exportReducers,
  ...exportReducers,
) as ActionReducer<IExportState, Action>;

export function useReducerFunc(state: any | undefined, action: Action) {
  return exportReducer(state, action);
}
